import styled from 'styled-components';
import { CheckboxField } from 'lib/iterable-hook-form/FormField';
import { StyledInput } from 'ui/inputs/InputStyles';
import { body2, caption, colors, fontWeights, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const Content = styled.div`
  display: flex;
  gap: ${spacing.half};
`;

export const StyledCheckboxField = styled(CheckboxField)`
  margin-top: ${spacing.eighth};
`;

export const Description = styled.p`
  ${caption}
  color: ${colors.textSecondary};
  margin-bottom: ${spacing.base};
`;

export const InputsWrapper = styled(Content)`
  display: flex;
  gap: ${spacing.half};
  align-items: center;
`;

export const RateLimitInputWrapper = styled.div`
  width: ${pxToRem(200)};
  ${StyledInput} {
    width: 100%;
  }
`;

export const RateLimitSelectWrapper = styled.div`
  width: ${pxToRem(105)};
`;

export const SeparatorText = styled.span`
  ${body2}
  font-weight: ${fontWeights.medium};
`;
